import React from 'react';
// import Select from 'react-select';

class StyleButton extends React.Component {
  constructor() {
    super();
    this.onToggle = (e) => {
      e.preventDefault();
      this.props.onToggle(this.props.style);
    };
  }

  render() {
    let className = 'RichEditor-styleButton';
    if (this.props.active) {
      className += ' RichEditor-activeButton';
    }

    return (
      <span className={className} onMouseDown={this.onToggle}>
        {this.props.label}
      </span>
    );
  }
}

const toolbarConfig = {
  // Optionally specify the groups to display (displayed in the order listed).
  display: [
    'INLINE_STYLE_BUTTONS',
    'BLOCK_TYPE_BUTTONS',
    'LINK_BUTTONS',
    'BLOCK_TYPE_DROPDOWN',
    'HISTORY_BUTTONS',
  ],
  INLINE_STYLE_BUTTONS: [
    { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
    { label: 'Italic', style: 'ITALIC' },
    { label: 'Underline', style: 'UNDERLINE' },
  ],
  BLOCK_TYPE_DROPDOWN: [
    { label: 'Normal', style: 'unstyled' },
    { label: 'Heading Large', style: 'header-one' },
    { label: 'Heading Medium', style: 'header-two' },
    { label: 'Heading Small', style: 'header-three' },
  ],
  BLOCK_TYPE_BUTTONS: [
    { label: 'UL', style: 'unordered-list-item' },
    { label: 'OL', style: 'ordered-list-item' },
  ],
};
const styleMap = {
  CODE: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
    fontSize: 16,
    padding: 2,
  },
};

const BLOCK_TYPES = [
  { label: 'H1', style: 'header-one' },
  { label: 'H2', style: 'header-two' },
  { label: 'H3', style: 'header-three' },
  { label: 'H4', style: 'header-four' },
  { label: 'H5', style: 'header-five' },
  { label: 'H6', style: 'header-six' },
  { label: 'Blockquote', style: 'blockquote' },
  { label: 'UL', style: 'unordered-list-item' },
  { label: 'OL', style: 'ordered-list-item' },
  { label: 'Code Block', style: 'code-block' },
];

const BlockStyleControls = (props) => {
  const { editorState } = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  return (
    <div className="RichEditor-controls">
      {BLOCK_TYPES.map((type) => (
        <StyleButton
          key={type.label}
          active={type.style === blockType}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      ))}
    </div>
  );
};

var INLINE_STYLES = [
  { label: 'Bold', style: 'BOLD' },
  { label: 'Italic', style: 'ITALIC' },
  { label: 'Underline', style: 'UNDERLINE' },
  { label: 'Monospace', style: 'CODE' },
];

const InlineStyleControls = (props) => {
  var currentStyle = props.editorState.getCurrentInlineStyle();
  return (
    <div className="RichEditor-controls">
      {INLINE_STYLES.map((type) => (
        <StyleButton
          key={type.label}
          active={currentStyle.has(type.style)}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      ))}
    </div>
  );
};

// import calendar style
const colourStyles = {
  control: (styles) => ({
    ...styles,
    // backgroundColor: 'white'
    cursor: 'pointer',
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    // const color = chroma(data.color);
    return {
      ...styles,
      textAlign: 'left',
      cursor: 'pointer',
    };
  },
};
const memberStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: 'transparent',
    marginLeft: 'auto',
    theme: 'primary',
    marginRight: 'auto',
    border: '1px solid #CCCCCC',
    borderRadius: '50%',
    padding: '0px',
    width: '40px',
    height: '40px',
    cursor: 'pointer',
  }),
  container: (styles) => ({
    ...styles,
    border: '0px solid #FFFFFF',
    padding: '3px',
  }),
  input: (styles) => ({ ...styles, border: '0px solid #FFFFFF' }),
  indicatorsContainer: (styles) => ({
    ...styles,
    border: '0px solid #FFFFFF',
    display: 'none',
  }),
  placeholder: (styles) => ({
    ...styles,
    border: '0px solid #FFFFFF',
    backgroundColor: 'transparent',
  }),
  valueContainer: (styles) => ({ ...styles, border: '0px solid #FFFFFF' }),
  menuList: (styles) => ({ ...styles, minWidth: '150px' }),
  menu: (styles) => ({ ...styles, minWidth: '150px' }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    // const color = chroma(data.color);
    return {
      ...styles,
      textAlign: 'left',
      cursor: 'pointer',
    };
  },
};
const slimColourStyles = {
  // menu: (provided, state) => ({
  //     ...provided,
  //     width: state.selectProps.width,
  //     // borderBottom: '1px dotted pink',
  //     // color: state.selectProps.menuColor,
  //     // padding: 20,
  // }),
  control: (styles) => ({
    ...styles,
    // backgroundColor: 'white',
    paddint: '5px',
    maxHeight: '50px',
    // maxWidth: '100px',
    marginLeft: 'auto',
    cursor: 'pointer',
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    // const color = chroma(data.color);
    return {
      ...styles,
      textAlign: 'left',
      cursor: 'pointer',
    };
  },
};
const SeverityList = {
  5: 'Critical',
  4: 'Urgent',
  3: 'Serious',
  2: 'Medium',
  1: 'Minimal',
};
const SourceTypeList = {
  was_data: 'Web Apps',
  sast: 'SAST',
  endpoint_data: 'Endpoints',
  'ca_data-all': 'Cloud Agents - All',
  ca_data: 'Cloud Agents - Servers',
  'ca_data-workstations': 'Cloud Agents - Workstations',
};
const TypeList = {
  open: 'Active - All',
  active: 'Existing',
  fixed: 'Fixed',
  new: 'New',
  reopened: 'Reopened',
};
const SeverityColor = {
  5: { color: '#950E05', fontWeight: '900' },
  4: { color: '#E12E0F', fontWeight: '900' },
  3: { color: '#ec250d', fontWeight: '600' },
  2: { color: '#FFA207', fontWeight: '600' },
  1: { fontWeight: '600' },
};
const severities = [
  { value: '', label: 'All' },
  { value: '5', label: 'Critical' },
  { value: '4', label: 'Urgent' },
  { value: '3', label: 'Serious' },
  { value: '2', label: 'Medium' },
  { value: '1', label: 'Minimal' },
];
const ISSUE_TYPES = [
  { value: '', label: 'All' },
  { value: 'VULNERABILITY', label: 'Vulnerability' },
  { value: 'BUG', label: 'Bugs' },
  { value: 'SENSITIVE_CONTENT', label: 'Sensitive Content' },
];
const CATEGORIES = [
  { value: '', label: 'All' },
  { value: '&knowledge_base__patchable=1', label: 'Patchable' },
  { value: '&knowledge_base__patchable=0', label: 'Non Patchable' },
  { value: '&severity__in=5,4', label: 'High Severity' },
  { value: '&assigned=true', label: 'Assigned' },
  { value: '&watching=true', label: 'Watching' },
];
const REPORT_CATEGORIES = [
  { value: '', label: 'All' },
  {
    value: '&category__contains=Tech Report|Technical Report',
    label: 'Technical',
  },
  { value: '&category__contains=Patch', label: 'Patchable' },
  // { value: "&knowledge_base__patchable=0", label: "Non Patchable" },
  { value: '&category__contains=High Severity Report', label: 'High Severity' },
  // { value: "&assigned=true", label: "Assigned" },
  // { value: "&watching=true", label: "Watching" },
];
const REPORT_FILTERS = [
  { value: '', label: 'All' },
  { value: '&category__contains=Active', label: 'Active' },
  { value: '&category__contains=Fixed', label: 'Fixed' },
  {
    value: '&category__contains=Tech Report|Technical Report',
    label: 'Technical',
  },
  { value: '&category__contains=Patch', label: 'Patchable' },
  { value: '&category__contains=High Severity Report', label: 'High Severity' },
];
const ActiveOrFixed = [
  { value: 'open', label: 'Active - All' },
  { value: 'active', label: 'Existing' },
  { value: 'fixed', label: 'Fixed' },
  { value: 'new', label: 'New' },
  { value: 'reopened', label: 'Reopened' },
];
const ACTIVE_OR_FIXED_CATEGORIES = [
  { value: '', label: 'All' },
  { value: '&active_or_fixed__contains=Active', label: 'Active' },
  { value: '&active_or_fixed__contains=Fixed', label: 'Fixed' },
  // { value: "&knowledge_base__patchable=0", label: "Non Patchable" },
  // { value: "&category__contains=High Severity Report", label: "High Severity" },
  // { value: "&assigned=true", label: "Assigned" },
  // { value: "&watching=true", label: "Watching" },
];
const SourceType = [
  { value: '', label: 'All' },
  { value: 'was_data', label: 'Web Apps' },
  { value: 'sast', label: 'SAST' },
  { value: 'endpoint_data', label: 'Endpoints' },
  { value: 'ca_data-all', label: 'Cloud Agents - All' },
  { value: 'ca_data', label: 'Cloud Agents - Servers', subtype: 'servers' },
  {
    value: 'ca_data-workstations',
    label: 'Cloud Agents - Workstations',
    subtype: 'workstations',
  },
];
const SourceTypeReport = [
  { value: '', label: 'All' },
  { value: '-WAS-', label: 'Web Apps' },
  { value: 'SAST', label: 'SAST' },
  { value: 'Endpoint Scan', label: 'Endpoints - All' },
  { value: 'External Endpoint Scan', label: 'Endpoints - External' },
  { value: 'Internal Endpoint Scan', label: 'Endpoints - Internal' },
  { value: 'Cloud Agent', label: 'Cloud Agents - All' },
  {
    value: 'Cloud Agent-Servers',
    label: 'Cloud Agents - Servers',
    subtype: 'servers',
  },
  {
    value: 'Cloud Agent-Workstations',
    label: 'Cloud Agents - Workstations',
    subtype: 'workstations',
  },
  { value: 'Compliance Report', label: 'Policy Compliance' },
];
const FORMAT_TYPES = [
  { value: '', label: 'All' },
  { value: 'CSV', label: 'CSV' },
  { value: 'PDF', label: 'PDF' },
  { value: 'HTML&HTML_BASE64', label: 'HTML' },
];
const PAGE_SIZES = [
  { value: '25', label: '25' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
  { value: '200', label: '200' },
];
const ACTIVE_OR_INACTIVE = [
  { value: 'true', label: 'Active' },
  { value: 'false', label: 'Inactive' },
];
const SCANS_FORMAT_TYPES = [
  { value: '', label: 'All' },
  { value: 'API', label: 'API' },
  { value: 'ONDEMAND', label: 'ONDEMAND' },
  { value: 'SCHEDULED', label: 'SCHEDULED' },
];
export {
  toolbarConfig,
  styleMap,
  BLOCK_TYPES,
  BlockStyleControls,
  INLINE_STYLES,
  InlineStyleControls,
  SourceTypeReport,
  colourStyles,
  memberStyles,
  slimColourStyles,
  SeverityList,
  SourceTypeList,
  TypeList,
  SeverityColor,
  severities,
  ISSUE_TYPES,
  FORMAT_TYPES,
  CATEGORIES,
  ActiveOrFixed,
  SourceType,
  PAGE_SIZES,
  REPORT_CATEGORIES,
  REPORT_FILTERS,
  ACTIVE_OR_FIXED_CATEGORIES,
  ACTIVE_OR_INACTIVE,
  SCANS_FORMAT_TYPES,
};
